// extracted by mini-css-extract-plugin
var _1 = "DescriptionField-moduledescriptionField__qTsrA";
export { _1 as "descriptionField" }
